import { Text } from '@frontend/legacy-components';

const LabelText = ({ children }) => (
  <Text
    textTransform="uppercase"
    fontSize="sm"
    fontWeight="heavy"
    color="feature.secondary"
    whiteSpace="nowrap"
  >
    {children}
  </Text>
);

export default LabelText;
